export class ProjectPaginationValues {
  constructor(public page: number, public rowsPerPage: number) {}
}
